(function () {
  var header = document.querySelector("[data-header]");
  var menu = document.querySelector("[data-menu]");
  var menuToggle = document.querySelector("[data-menu-toggle]");
  var scrollLinks = document.querySelectorAll("[data-scroll]");
  var counters = document.querySelectorAll("[data-counter]");
  var slides = document.querySelectorAll("[data-slide]");
  var prevButton = document.querySelector("[data-slider-prev]");
  var nextButton = document.querySelector("[data-slider-next]");
  var lightboxPanel = document.querySelector("[data-lightbox-panel]");
  var lightboxClose = document.querySelector("[data-lightbox-close]");
  var lightboxImage = lightboxPanel ? lightboxPanel.querySelector("img") : null;
  var localPreviewForm = document.querySelector(".contact-form:not([action])");
  var activeSlide = 0;

  function updateHeader() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  }

  function closeMenu() {
    if (!menu || !menuToggle) return;
    menu.classList.remove("is-open");
    header && header.classList.remove("is-open");
    menuToggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("menu-open");
  }

  function scrollToTarget(anchor) {
    var target = document.querySelector(anchor);
    if (!target) return;
    closeMenu();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  if (menuToggle && menu) {
    menuToggle.addEventListener("click", function () {
      var isOpen = menu.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", String(isOpen));
      header && header.classList.toggle("is-open", isOpen);
      document.body.classList.toggle("menu-open", isOpen);
    });
  }

  scrollLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      var href = link.getAttribute("href");
      if (!href || href.charAt(0) !== "#") return;
      event.preventDefault();
      scrollToTarget(href);
    });
  });

  function animateCounter(counter) {
    var target = Number(counter.getAttribute("data-target") || 0);
    var start = 0;
    var duration = 1200;
    var started = performance.now();

    function tick(now) {
      var progress = Math.min((now - started) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      counter.textContent = Math.round(start + (target - start) * eased).toLocaleString("pl-PL");
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  if ("IntersectionObserver" in window && counters.length) {
    var counterObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.target.dataset.done) return;
        entry.target.dataset.done = "true";
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.45 });
    counters.forEach(function (counter) { counterObserver.observe(counter); });
  } else {
    counters.forEach(animateCounter);
  }

  function showSlide(index) {
    if (!slides.length) return;
    activeSlide = (index + slides.length) % slides.length;
    slides.forEach(function (slide, slideIndex) {
      slide.classList.toggle("active", slideIndex === activeSlide);
    });
  }

  if (prevButton) prevButton.addEventListener("click", function () { showSlide(activeSlide - 1); });
  if (nextButton) nextButton.addEventListener("click", function () { showSlide(activeSlide + 1); });
  if (slides.length > 1) {
    window.setInterval(function () { showSlide(activeSlide + 1); }, 6800);
  }

  document.querySelectorAll("[data-lightbox]").forEach(function (tile) {
    tile.addEventListener("click", function () {
      if (!lightboxPanel || !lightboxImage) return;
      lightboxImage.src = tile.getAttribute("data-lightbox");
      lightboxPanel.hidden = false;
      document.body.classList.add("lightbox-open");
    });
  });

  function closeLightbox() {
    if (!lightboxPanel || !lightboxImage) return;
    lightboxPanel.hidden = true;
    lightboxImage.removeAttribute("src");
    document.body.classList.remove("lightbox-open");
  }

  if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
  if (lightboxPanel) {
    lightboxPanel.addEventListener("click", function (event) {
      if (event.target === lightboxPanel) closeLightbox();
    });
  }

  if (localPreviewForm) {
    localPreviewForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var success = localPreviewForm.querySelector(".form-success");
      if (!success) {
        success = document.createElement("p");
        success.className = "form-success";
        localPreviewForm.prepend(success);
      }
      success.textContent = "Dziękujemy. Formularz w podglądzie działa lokalnie.";
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeMenu();
      closeLightbox();
    }
  });

  updateHeader();
  window.addEventListener("scroll", updateHeader, { passive: true });
})();
